import { render } from "./ModalSave.vue?vue&type=template&id=72d38b7b&scoped=true"
import script from "./ModalSave.vue?vue&type=script&lang=js"
export * from "./ModalSave.vue?vue&type=script&lang=js"

import "./ModalSave.vue?vue&type=style&index=0&id=72d38b7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d38b7b"]])

export default __exports__